import React from "react";

export default function ColorControl({ label, value, onChange }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
        marginBottom: "10px",
      }}
    >
      <span
        style={{
          fontFamily: "monospace",
          fontSize: "10px",
          color: "#858d87",
        }}
      >
        {label}
      </span>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <span
          style={{
            fontFamily: "monospace",
            fontSize: "9px",
            color: "#858d87",
          }}
        >
          {value.toUpperCase()}
        </span>

        <input
          type="color"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          style={{
            width: "32px",
            height: "24px",
            padding: 0,
            border: "1px solid #303631",
            background: "transparent",
            cursor: "pointer",
          }}
        />
      </div>
    </div>
  );
}
